<template>
    <a-layout style="min-height: 100vh">
        <router-view></router-view>
   </a-layout>
</template>

<script lang="ts">
    import { Vue } from 'vue-class-component'
    export default class Home extends Vue {
        public mounted() { }
    }
</script>

